import React from 'react'
import SelectableCard from 'components/JarCard/SelectableCard'
import useCurrentUserEntities from 'hooks/useCurrentUserEntities'
import { Grid, Typography, Box, Link } from '@material-ui/core'
import { updateUser } from 'actions/users'

import useCurrentUserProp from 'hooks/useCurrentUserProp'
import { stopRoundups, startRoundups } from 'actions/campaigns'
import { useDispatch } from 'react-redux'
import RoundupCap from 'components/Fields/RoundupCap'
import useFormExpanded from 'hooks/useFormExpanded'
import { FormProvider } from 'react-hook-form'
import { InfoOutlined } from '@material-ui/icons'

export default function SetupRoundups({ completeStep, Footer }) {
  const jarIds = useCurrentUserProp('campaigns')
  const roundedUpJarIds = useCurrentUserProp('roundedUpJars')
  const userId = useCurrentUserProp('id')
  const dispatch = useDispatch()
  const roundedUpJars = useCurrentUserEntities('campaigns', 'roundedUpJars')
  const formMethods = useFormExpanded()
  const { handleSubmit, setFieldValidationErrors, hasErrors } = formMethods

  function handleStopRoundups(jarId) {
    dispatch(stopRoundups(userId, jarId))
  }

  function handleStartRoundups(jarId) {
    dispatch(startRoundups(userId, jarId))
  }

  function saveAndContinue(values) {
    dispatch(updateUser(userId, values))
    .then(() => {
      completeStep('Setup Roundups')
    })
    .catch((errorResponse) => {
      setFieldValidationErrors(errorResponse)
    })
  }

  const footerText = () => {
    if (roundedUpJars.length > 0) {
      return (
        <React.Fragment>
          With your current settings, you will roundup your purchases
          {roundedUpJarIds.length > 1 ? (
            <span> for <strong>{roundedUpJarIds.length}</strong> funds</span>
          ) : (
            <span> for <strong>{roundedUpJars[0].name}</strong></span>
          )}
        </React.Fragment>
      )
    }

    return 'You are not rounding up your purchases. You can update this later!'
  }

  return (
    <FormProvider { ...formMethods }>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6} md={4} component={Box} textAlign='center'>
          <Typography paragraph variant='h4' component='h1'>Setup Roundups</Typography>
          <Typography variant='body2' paragraph>
            You’re also able to roundup all of your daily purchases to the nearest dollar in support of our causes.<br/>
            <Link target='_blank' rel='noopener noreferrer' href='https://sixpenceapp.com/faq/' variant='body2'>
              How do roundups work?
              <sup><InfoOutlined fontSize='inherit' /></sup>
            </Link>
          </Typography>
          <Typography variant='body2' gutterBottom>
            If you’d like to set a monthly maximum total for your roundup giving, enter the $ max amount below. Leave blank if you don't wish to set a maximum.
          </Typography>
          <RoundupCap margin='normal' />
        </Grid>

        <Grid container item xs={12} sm={6} md={8} spacing={1} justifyContent='center'>
          <Grid item xs={12}>
            <Typography variant='body2' align='center' gutterBottom>
              Choose efforts you’d like to roundup to below.
            </Typography>
            <Typography variant='body2' align='center'>
              <i>Deselect all funds to proceed without rounding up.</i>
            </Typography>
          </Grid>
          {jarIds.map((id) => (
            <Grid key={id} item xs={12} md={6}>
              <SelectableCard
              id={id}
                selected={roundedUpJarIds.includes(id)}
                onSelect={() => handleStartRoundups(id)}
                onDeselect={() => handleStopRoundups(id)}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Footer
        additionalText={footerText()}
        handleClickNext={handleSubmit(saveAndContinue)}
        disableNextButton={hasErrors}
      />
    </FormProvider>
  )
}
